var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.errorMessage)?_c('div',{staticClass:"text-center link-dataset"},[_c('h4',{staticStyle:{"font-weight":"bold"}},[_c('lottie',{attrs:{"options":{
        animationData: _vm.animationData,
        loop: true,
        autoplay: true,
      },"width":_vm.width,"height":_vm.height}}),_c('br'),_vm._v(" "+_vm._s(_vm.errorMessage)+" ")],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }